import { NextHead } from "../../src/landingPage/layouts/LayoutComponents/NextHead";
import butter from "../../src/landingPage/utils/butter-client";
import { LandingTemplate } from "../../src/landingPage/views/LandingTemplate/LandingTemplate";

const WebinarRegistrationPage = ({ heroData, mainData, meta, resolvedUrl }) => {
  return (
    <>
      <NextHead
        currentPath={resolvedUrl}
        title={meta?.title}
        description={meta?.description}
        pageImageUrl={meta?.image}
      />
      <LandingTemplate heroData={heroData} mainData={mainData} />
    </>
  );
};
export default WebinarRegistrationPage;

export const getServerSideProps = async ctx => {
  try {
    const { slug } = ctx.params;
    const { resolvedUrl } = ctx;
    const response = await butter.page.retrieve("landing", slug);
    const data = response?.data?.data;

    const heroData = data?.fields?.hero;
    const { meta } = data?.fields;
    const mainData = data?.fields?.main_content;
    return {
      props: {
        heroData,
        mainData,
        meta,
        resolvedUrl,
      },
    };
  } catch (e) {
    return {
      notFound: true,
    };
  }
};
